'use strict';

// Packages
import 'jquery';
import '@popperjs/core';
import 'bootstrap';
import 'slick-slider';
import './components/codemirror-init';

import Codemirror from './components/codemirror';
import Form from './components/form';
import Modal from './components/modal';
import LazyLoading from './components/lazyload';
import Nav from './components/nav';
import Slider from './components/slider';
import Utils from './components/utils';
import SubnavScroll from './components/subnavscroll';
import Validation from './components/validation';
import CustomerIO from './components/customer-io';

$(function() {
  new Codemirror();
  new Form();
  new Modal();
  new LazyLoading();
  new Nav();
  new Slider();
  new Utils();
  new SubnavScroll();
  new Validation();
  new CustomerIO();
});